import { ComponentInstall } from "../../utils";
import Switch from "./src";

export default ComponentInstall(Switch);
